import { __extends } from "tslib";
import React, { Component } from 'react';
import Context from '../../common/Utils/Context';
import { mergeStyles } from '../../common/Utils/mergeStyles';
import { validate } from '../../common/Utils/data-schema-validator';
import isEqual from 'lodash/isEqual';
import schema from './data-schema.json';
import styles from './giphy-viewer.scss';
var GiphyViewer = /** @class */ (function (_super) {
    __extends(GiphyViewer, _super);
    function GiphyViewer(props) {
        var _this = _super.call(this, props) || this;
        validate(props.componentData, schema);
        return _this;
    }
    // eslint-disable-next-line
    GiphyViewer.prototype.componentWillReceiveProps = function (nextProps) {
        if (!isEqual(nextProps.componentData, this.props.componentData)) {
            validate(nextProps.componentData, schema);
        }
    };
    GiphyViewer.prototype.render = function () {
        this.styles =
            this.styles || mergeStyles({ styles: styles, theme: this.context.theme });
        var componentData = this.props.componentData;
        return (React.createElement("img", { className: this.styles.giphy_player, src: componentData.gif.originalUrl, alt: "gif" }));
    };
    return GiphyViewer;
}(Component));
GiphyViewer.contextType = Context.type;
export default GiphyViewer;
//# sourceMappingURL=giphy-viewer.js.map